import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface AlertModel {
  serasaObj;
}

/**
 * Exibe consultas Serasa Concentre (PF) antigas, gravadas no formato legado (ReturnConcentre)
 * antes da migração para a integração REST InfoMais. Mantido separado do ConcentreComponent
 * (que atende exclusivamente o formato novo) para não alterar a integração REST atual.
 */
@Component({
  selector: 'app-concentre-legado',
  templateUrl: './concentre-legado.component.html',
  styleUrls: ['./concentre-legado.component.scss']
})
export class ConcentreLegadoComponent extends DialogComponent<AlertModel, boolean> implements AlertModel, OnInit {

  private participacaoSocietaria = [];
  serasaObj: any;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    this.participacaoSocietaria = ((this.serasaObj && this.serasaObj['ParticipacaoSocietarias']) || []).filter(element => element.Mensagem == null);
  }

  closeModal() {
    this.close();
  }

  sumTotais(obj) {
    let total = 0;
    for (var i = 0; i < obj.length; i++) {
      if (obj[i].ValorOcorrencia) {
        total += obj[i].ValorOcorrencia;
      }
      else if (obj[i].Valor) {
        total += obj[i].Valor;
      }
    }
    return total;
  }

  formataData(periodo) {
    return periodo.replace(/00:00:00/g, "");
  }
}



// WEBPACK FOOTER //
// ./src/app/serasa/component/serasa/concentre-legado/concentre-legado.component.ts